import Star from "../assets/images/star.webp"
import { Disclosure } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';

const faqData = [
        { 
            question: "What is Star123?", 
            answer: "Star123 is an informational platform that provides updated results, charts, and related data in a simple and user-friendly format." 
        },
        { 
            question: "Is Star123 free to use?", 
            answer: "Yes, Star123 is completely free to use. No charges are required to access results or charts." 
        },
        { 
            question: "Do I need to register or log in to use Star123?", 
            answer: "No, users can access all information on Star123 without any registration or login." 
        },
        { 
            question: "How often are results updated on Star123?", 
            answer: "Results are updated regularly as soon as official data becomes available." 
        },
        { 
            question: "Can I check today's latest results on Star123?", 
            answer: "Yes, today's latest results are available on the homepage and the results section." 
        },
        { 
            question: "Can I view old or previous results?", 
            answer: "Yes, Star123 provides historical results and charts for user reference." 
        },
        { 
            question: "Is Star123 safe and secure to use?", 
            answer: "Yes, Star123 is safe to browse and does not ask for any personal or financial information." 
        },
        { 
            question: "Does Star123 promote gambling?", 
            answer: "No, Star123 is strictly an informational website. We do not promote, support, or encourage gambling in any form." 
        },
        { 
            question: "Can I use Star123 on mobile devices?", 
            answer: "Yes, Star123 is fully responsive and works smoothly on mobile phones, tablets, and desktop devices." 
        },
        { 
            question: "Is there a Star123 mobile app available?", 
            answer: "Currently, Star123 is accessible via the website. If a mobile app is launched in the future, updates will be shared on the site." 
        },
        { 
            question: "How accurate is the information on Star123?", 
            answer: "We strive to provide accurate and timely information. However, users are advised to verify information from official sources when needed." 
        },
        { 
            question: "What should I do if I find incorrect information?", 
            answer: "If you notice any incorrect or outdated data, please contact us so we can review and update it promptly." 
        },
        { 
            question: "Does Star123 collect or store user data?", 
            answer: "No, Star123 does not collect or store any personal user data." 
        },
        { 
            question: "How can I contact Star123 support?", 
            answer: "You can contact us through the details available on the Contact Us page of the website." 
        },
        { 
            question: "Can I suggest features or improvements for Star123?", 
            answer: "Yes, we welcome user feedback and suggestions to help us improve Star123." 
        },
        { 
            question: "Where can I find Star123's Privacy Policy and Terms?", 
            answer: "Our Privacy Policy and Terms & Conditions pages are available via links at the bottom of the website." 
        },
    ];

const FAQs = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = 'star123-faq-schema';
        script.text = JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((item) => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: item.answer,
                },
            })),
        });
        document.head.appendChild(script);
        return () => {
            script.remove();
        };
    }, []);

    return (
        <section id="faqs" className="faqSection">
            <div className="container">
                <div className="row my-lg-5 py-lg-5 my-4">
                    <div className="col-lg-12">
                        <div className="faq-header text-center mb-5">
                            <div className="faq-title-wrapper d-inline-flex align-items-center justify-content-center gap-3 mb-3">
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    loading="lazy"
                                    width={40}
                                    height={40}
                                    decoding="async"
                                    src={Star}
                                    className="faq-star-icon"
                                />
                                <h2 className="display-5 fw-bolder color-primary mb-0">
                                    Frequently Asked Questions
                                </h2>
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    loading="lazy"
                                    width={40}
                                    height={40}
                                    decoding="async"
                                    src={Star}
                                    className="faq-star-icon"
                                />
                            </div>
                            {/* <p className="faq-subtitle text-muted">Find answers to common questions about Star123</p> */}
                        </div>
                    </div>
                    <div className="col-lg-10 offset-lg-1">
                        <div className="faq-container">
                            {faqData.map((item, index) => (
                                <Disclosure key={index}>
                                    {({ open }) => (
                                        <div className={`faq-item ${open ? 'faq-item-active' : ''}`}>
                                            <Disclosure.Button className="faq-question">
                                                <div className="faq-question-content">
                                                    <FontAwesomeIcon 
                                                        icon={faQuestionCircle} 
                                                        className="faq-icon me-3"
                                                    />
                                                    <span className="faq-question-text">{item.question}</span>
                                                </div>
                                                <FontAwesomeIcon 
                                                    icon={faChevronDown} 
                                                    className={`faq-chevron ${open ? 'faq-chevron-open' : ''}`}
                                                />
                                            </Disclosure.Button>
                                            <Disclosure.Panel className="faq-answer">
                                                <div className="faq-answer-content">
                                                    {item.answer}
                                                </div>
                                            </Disclosure.Panel>
                                        </div>
                                    )}
                                </Disclosure>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQs;
